import { useCallback, useMemo, useRef } from "react";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { setBlur, setShowLegalDialog } from "../../redux/reducers/uiReducer";

import { logDebug } from "../../utils/logger";
import { isEmpty } from "../../utils/validators";

function LegalDialog() {
  const { t } = useTranslation();

  const dialogRef = useRef(null);

  const dispatch = useDispatch();
  const { ui } = useSelector((state) => state);
  const { contact_z_index } = ui;

  const zIndex = useMemo(() => {
    return !isEmpty(contact_z_index) ? parseInt(contact_z_index) : 101;
  }, [contact_z_index]);

  const onClickCloseDialogHandler = useCallback(
    (evt) => {
      logDebug("LegalDialog", "onClickCloseDialogHandler", { evt: evt });
      dispatch(setBlur(false));
      dispatch(setShowLegalDialog(false));
    },
    [dispatch]
  );

  return (
    <>
      <div className="wrapper" style={{ zIndex: zIndex + 2 }}></div>
      <div
        ref={dialogRef}
        className="legal-dialog"
        style={{ zIndex: zIndex + 3 }}
      >
        <div className="legal-dialog__header">
          <span className="legal-dialog__header__logo"></span>
          <div className="legal-dialog__header__title header-3">
            {t("legal_warn.title")}
          </div>
          <div className="legal-dialog__header__subtitle text-body">
            {t("legal_warn.description")}
          </div>
          <span
            className="legal-dialog__header__icon icon-close"
            title={t("button.close")}
            onClick={(evt) => onClickCloseDialogHandler(evt)}
          />
        </div>
        <div className="legal-dialog__body">
          <div
            className="legal-dialog__body__content"
            dangerouslySetInnerHTML={{
              __html: t("legal_warn.content", {
                interpolation: { escapeValue: true },
              }),
            }}
          ></div>
        </div>
        <div className="legal-dialog__footer"></div>
      </div>
    </>
  );
}

export default LegalDialog;
